var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#FFEDEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.9444 43.9997H25.2778C23.278 43.9997 21.6667 42.2809 21.6667 40.1478V24.1478H20.8333C20.3613 24.1478 20 23.7624 20 23.2589V22.37C20 21.8666 20.3613 21.4812 20.8333 21.4812H41.3889C41.8609 21.4812 42.2222 21.8666 42.2222 22.37V23.2589C42.2222 23.7624 41.8609 24.1478 41.3889 24.1478H40.5556V40.1478C40.5556 42.2809 38.9442 43.9997 36.9444 43.9997ZM35 28.296H33.8889C33.4169 28.296 33.0556 28.6814 33.0556 29.1849V38.0737C33.0556 38.5772 33.4169 38.9626 33.8889 38.9626H35C35.472 38.9626 35.8333 38.5772 35.8333 38.0737V29.1849C35.8333 28.6814 35.472 28.296 35 28.296ZM28.3333 28.296H27.2222C26.7502 28.296 26.3889 28.6814 26.3889 29.1849V38.0737C26.3889 38.5772 26.7502 38.9626 27.2222 38.9626H28.3333C28.8053 38.9626 29.1667 38.5772 29.1667 38.0737V29.1849C29.1667 28.6814 28.8053 28.296 28.3333 28.296ZM34.1667 19.9997H28.0556C27.5836 19.9997 27.2222 19.6143 27.2222 19.1108V18.2219C27.2222 17.7184 27.5836 17.333 28.0556 17.333H34.1667C34.6387 17.333 35 17.7184 35 18.2219V19.1108C35 19.6143 34.6387 19.9997 34.1667 19.9997Z",
    fill: "#FE434C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrash);
export default __webpack_public_path__ + "static/media/iconTrash.cd9b2ef2dccce5fa65d62faf2d07b44e.svg";
export { ForwardRef as ReactComponent };